import EncryptionUtil from "./encryptionUtil";

const agentCache = {};

function clearOldCacheIfNeeded() {
  const lastClear = localStorage.getItem("agents_cache_last_clear");
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

  if (lastClear !== today) {
    // Clear all keys that start with 'agents_cache_'
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith("agents_cache_")) {
        localStorage.removeItem(key);
      }
    });
    localStorage.setItem("agents_cache_last_clear", today);
  }
}

export function fetchAgentsOnce(roles, serverUrl) {
  const key = roles || "none";
  clearOldCacheIfNeeded();

  // 1. From memory cache
  if (agentCache[key]) {
    return Promise.resolve(agentCache[key]);
  }

  // 2. From localStorage
  const encrypted = localStorage.getItem("agents_cache_" + key);
  if (encrypted) {
    try {
      const decrypted = EncryptionUtil.decrypt(encrypted);
      agentCache[key] = decrypted;
      return Promise.resolve(decrypted);
    } catch (e) {
      console.warn("Failed to decrypt agents cache", e);
    }
  }

  // 3. Fetch from server
  return fetch(`${serverUrl}AgentRole`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(roles.split('|')),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      const safeData = data.data || [];
      const decrypted = EncryptionUtil.deobfuscate(safeData)
      agentCache[key] = decrypted;

      try {
        const encrypted = EncryptionUtil.encrypt(decrypted);
        localStorage.setItem("agents_cache_" + key, encrypted);
      } catch (e) {
        console.warn("Failed to encrypt and store agent data", e);
      }

      return decrypted;
    })
    .catch((error) => {
      console.error("Error fetching agents:", error);
      return [];
    });
}
